module.exports = __webpack_public_path__ + "static/media/cr3.61feae8e.png";